module.exports = __webpack_public_path__ + "065268062ef00e2d34d3db373a6dbf5c.svg";